import { Behavior } from "../Behavior";
import type { Particle } from "../Particle";
import type { IGrid } from "../types";
import { Empty } from "../particles/Empty";

export class Explode extends Behavior {
    threshold: number;
    radius: number;
    fireFactory: () => Particle;
    chance: number; // 膨胀填充概率

    constructor(threshold: number, radius: number, fireFactory: () => Particle, chance: number = 0.5) {
        super();
        this.threshold = threshold;
        this.radius = radius;
        this.fireFactory = fireFactory;
        this.chance = chance;
    }

    update(particle: Particle, grid: IGrid, index: number): number | void {
        if (particle.temperature < this.threshold) return;

        const cx = index % grid.width;
        const cy = Math.floor(index / grid.width);
        
        // 自身变成 Empty (爆炸消耗了自身)
        const empty = new Empty();
        empty.temperature = Math.max(particle.temperature, 1200); 
        empty.updated = true; 
        grid.setIndex(index, empty);

        const r = this.radius;
        const rSq = r * r;

        for (let y = -r; y <= r; y++) {
            for (let x = -r; x <= r; x++) {
                if (x === 0 && y === 0) continue;
                if (x*x + y*y > rSq) continue;

                const nx = cx + x;
                const ny = cy + y;

                if (nx < 0 || nx >= grid.width || ny < 0 || ny >= grid.height) continue;

                const nIdx = ny * grid.width + nx;
                const neighbor = grid.pixels[nIdx];

                if (neighbor.empty) {
                    // 膨胀：在空位生成火，概率降低，避免过多
                    // 但由于自身变为空，为了视觉效果，我们可以稍微增加一点中心区域的火焰密度
                    // 或者距离中心越近概率越高
                    const distSq = x*x + y*y;
                    const prob = this.chance * (1 - distSq / (rSq * 1.5)); // 距离越远概率越低

                    if (Math.random() < Math.max(0.1, prob)) {
                         const f = this.fireFactory();
                         f.temperature = Math.max(particle.temperature, 1200);
                         f.updated = true;
                         grid.setIndex(nIdx, f);
                    }
                } else {
                    // 冲击：加热邻居
                    // 剧烈加热会触发邻居的相变或爆炸（如果是火药）
                    neighbor.temperature += 600; 
                    
                    // 如果邻居是不可燃的固体（如石头），也可以考虑给它一个向外的速度（如果是粒子系统支持动量的话）
                    // 目前不支持，所以只加热
                }
            }
        }
        
        return -1; // 自身已处理（变成了新粒子）
    }
}
